import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Calendar, Clock, ArrowRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

function useCountdown(date) {
  const [remain, setRemain] = useState('');
  useEffect(() => {
    const upd = () => {
      const diff = new Date(date).getTime() - Date.now();
      if (diff <= 0) return setRemain('Live');
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      setRemain(d > 0 ? `${d}d ${h}h left` : `${h}h ${m}m left`);
    };
    upd();
    const id = setInterval(upd, 60000);
    return () => clearInterval(id);
  }, [date]);
  return remain;
}

export default function PujaCard({ puja }) {
  const { lang, t } = useLang();
  const T = {
    participate: { en: 'Participate Now', hi: 'भाग लें' },
    at: { en: 'at', hi: 'में' }
  };
  const remain = useCountdown(puja.date);

  return (
    <div className="puja-card card-lift bg-white rounded-2xl overflow-hidden border border-orange-100 shadow-sm flex flex-col h-full">
      <div className="relative aspect-[4/3] overflow-hidden bg-orange-50">
        <img src={puja.image} alt={t({ en: puja.title_en, hi: puja.title_hi })} className="w-full h-full object-cover hover:scale-105 transition duration-500" loading="lazy" />
        <div className="absolute top-3 left-3 pill">
          <Clock className="w-3 h-3" /> {remain}
        </div>
      </div>
      <div className="p-4 md:p-5 flex-1 flex flex-col">
        <h3 className="font-semibold text-sm md:text-base text-stone-900 leading-snug mb-3 line-clamp-3 min-h-[3rem] md:min-h-[3.5rem]">
          {lang === 'en' ? puja.title_en : puja.title_hi}
        </h3>
        <div className="bg-amber-50 border border-amber-100 rounded-lg px-3 py-2 mb-2 flex items-start gap-2 text-xs md:text-sm">
          <MapPin className="w-3.5 h-3.5 md:w-4 md:h-4 text-amber-700 shrink-0 mt-0.5" />
          <span className="text-stone-700 line-clamp-2">{t(T.at)} {lang === 'en' ? puja.temple_en : puja.temple_hi}</span>
        </div>
        <div className="bg-blue-50 border border-blue-100 rounded-lg px-3 py-2 mb-4 flex items-center gap-2 text-xs md:text-sm">
          <Calendar className="w-3.5 h-3.5 md:w-4 md:h-4 text-blue-700 shrink-0" />
          <span className="text-stone-700 line-clamp-1">{lang === 'en' ? puja.date_label_en : puja.date_label_hi}</span>
        </div>
        {typeof puja.price === 'number' && puja.price > 0 && (
          <div className="flex items-baseline gap-2 mb-4">
            <span className="text-[10px] text-nv-muted uppercase tracking-wide font-semibold">
              {lang === 'en' ? 'From' : 'शुरू'}
            </span>
            <span className="text-lg font-bold text-orange-700">₹ {puja.price}</span>
            {puja.originalPrice && puja.originalPrice > puja.price && (
              <>
                <span className="text-xs text-stone-400 line-through">₹ {puja.originalPrice}</span>
                <span className="text-[10px] font-bold text-green-700 bg-green-100 rounded px-1.5 py-0.5">
                  {Math.round(((puja.originalPrice - puja.price) / puja.originalPrice) * 100)}% OFF
                </span>
              </>
            )}
          </div>
        )}
        <Link
          to={`/pujas/${puja.slug}`}
          className="mt-auto btn-orange rounded-lg py-2.5 md:py-3 flex items-center justify-center gap-2 font-semibold text-xs md:text-sm"
        >
          {t(T.participate)} <ArrowRight className="w-3.5 h-3.5 md:w-4 md:h-4" />
        </Link>
      </div>
    </div>
  );
}
